/**
 * 잔액 조회 Hook
 * 사용자의 출금 가능 잔액을 조회하고 관리합니다.
 */
import { useState, useEffect, useCallback } from 'react';
import { getWithdrawalAccount } from '../../../settlement/withdrawal/api/withdrawalApi';

interface UseBalanceReturn {
    balance: number;
    isLoading: boolean;
    error: string | null;
    refreshBalance: () => Promise<void>;
}

export const useBalance = (): UseBalanceReturn => {
    const [balance, setBalance] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchBalance = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            const response = await getWithdrawalAccount();
            
            if (response.success && response.balAmt !== undefined) {
                setBalance(response.balAmt);
            } else {
                setBalance(0);
                setError(response.message || '잔액 조회에 실패했습니다.');
            }
        } catch (err) {
            console.error('Failed to fetch balance:', err);
            setBalance(0);
            setError('잔액 조회 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    }, []);

    const refreshBalance = useCallback(async () => {
        await fetchBalance();
    }, [fetchBalance]);

    useEffect(() => {
        fetchBalance();
    }, [fetchBalance]);

    return {
        balance,
        isLoading,
        error,
        refreshBalance,
    };
};
